import script from "./talking-point-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./talking-point-item.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__